import { isRejectedWithValue } from "@reduxjs/toolkit";

import type { Middleware } from "@reduxjs/toolkit";

interface MutationErrorState {
  error: unknown;
  timestamp: number;
}

let lastMutationError: MutationErrorState | null = null;

export const getLastMutationError = (): unknown | null => {
  if (lastMutationError && Date.now() - lastMutationError.timestamp < 2000) {
    return lastMutationError.error;
  }

  return null;
};

export const clearLastMutationError = (): void => {
  lastMutationError = null;
};

export const lastMutationErrorMiddleware: Middleware =
  () => (next) => (action: any) => {
    if (isRejectedWithValue(action)) {
      if (action.type?.endsWith("/executeMutation/rejected")) {
        lastMutationError = {
          error: action.payload,
          timestamp: Date.now(),
        };
      }
    }

    return next(action);
  };
